<template>
  <router-view />
</template>

<script>
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'App',
  async mounted() {
    const authStore = useAuthStore();
    if (authStore.isAuthenticated) {
      await authStore.fetchCurrentUser();
    }
  },
};
</script>
